import { inject } from '@angular/core';
import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import Swal from 'sweetalert2';
import { TranslationService } from '../translation.service';

function getTokenFromSession(): string | null {
  const stored = sessionStorage.getItem('1000');
  if (!stored) {
    return null;
  }
  try {
    return  stored
  } catch {
    return null;
  }
}

function isTokenExpired(token: string): boolean {
  const parts = token.split('.');
  if (parts.length !== 3) {
    return false;
  }
  try {
    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const payloadJson = atob(base64);
    const payload = JSON.parse(payloadJson);
    if (!payload || typeof payload.exp !== 'number') {
      return false;
    }
    const now = Math.floor(Date.now() / 1000);
    return payload.exp <= now;
  } catch {
    return false;
  }
}
export const jwtInterceptor: HttpInterceptorFn = (req, next) => {
  const translationService = inject(TranslationService);
  
  const authReq = req.clone({
    withCredentials: true
  });

  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      handleApiError(error, translationService);
      return throwError(() => error);
    })
  );
};

function handleApiError(error: HttpErrorResponse, translationService: TranslationService) {
  let errorMessage = translationService.getMessage('generic_error');
  let errorTitle = translationService.getMessage('error_title');

  switch (error.status) {
    case 0:
      errorTitle = translationService.getMessage('connection_error_title');
      errorMessage = translationService.getMessage('connection_error');
      break;
    case 400:
      errorTitle = translationService.getMessage('bad_request_title');
      errorMessage = error.error?.message || translationService.getMessage('bad_request_error');
      break;
    case 401:
      errorTitle = translationService.getMessage('unauthorized_title');
      errorMessage = translationService.getMessage('unauthorized_error');
      // Don't show alert for 401, let the auth service handle it
      return;
    case 403:
      errorTitle = translationService.getMessage('forbidden_title');
      errorMessage = translationService.getMessage('forbidden_error');
      break;
    case 404:
      errorTitle = translationService.getMessage('not_found_title');
      errorMessage = translationService.getMessage('not_found_error');
      break;
    case 500:
      errorTitle = translationService.getMessage('server_error_title');
      errorMessage = translationService.getMessage('server_error');
      break;
    case 502:
    case 503:
    case 504:
      errorTitle = translationService.getMessage('service_unavailable_title');
      errorMessage = translationService.getMessage('service_unavailable_error');
      break;
    default:
      errorMessage = error.error?.message || `HTTP Error: ${error.status}`;
      break;
  }

  // Show SweetAlert error
  Swal.fire({
    icon: 'error',
    title: errorTitle,
    text: errorMessage,
    confirmButtonText: translationService.getMessage('ok_button'),
    confirmButtonColor: '#d33',
    timer: 10000,
    timerProgressBar: true
  });
}
// export const jwtInterceptor: HttpInterceptorFn = (req, next) => {
//   const token = getTokenFromSession();
//   if (!token) {
//     return next(req);
//   }

//   if (isTokenExpired(token)) {
//      const router = inject(Router);
//     router.navigate(['/login']);
//     return next(req);
//   }

//   const authReq = req.clone({
//     setHeaders: {
//       Authorization: `Bearer ${token}`
//     }
//   });

//   return next(authReq);
// };

